import React from "react";
import { useParams } from "react-router-dom";
import Page from "../Components/Page";
import PasswordForm from "../features/auth/PasswordForm";
import useFetchData from "../hooks/useFetchData";
import { IUser } from "../features/users/types";
import { useTranslation } from "react-i18next";

export default function PasswordPage() {
  const params = useParams();
  const { data: user, isLoading } = useFetchData<IUser>(
    `/users/${params.userid}`
  );
  const { t } = useTranslation();
  return (
    <Page title={t("Set Password")} isLoading={isLoading}>
      {user && <PasswordForm user={user} />}
    </Page>
  );
}
